import Box from './Box';
import React, { useState } from "react"
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const PopupExample = () => (<Popup trigger={<button> Trigger</button>} position="right center">    <div>Popup content here !!</div>  </Popup>);

function BiggestBox({ uuid }) {
    const [things, setThings] = useState(
        { id: "b" + uuid, className: "biggestBox", children: [], holds: "BOX" }
    )

    function ondrop(droppedItem, childID) {
        if (droppedItem.id === childID || droppedItem.parent === childID)
            return

        let childToPass = { id: droppedItem.id, className: droppedItem.className }

        droppedItem.move()

        this.setState(state => ({
            childToPass: childToPass
        }))
    }

    return (
        <div>
            <Box id={things.id} holds={things.holds} className={things.className}>First Box</Box>
        </div>
    )
}

export default BiggestBox